module.exports = __webpack_public_path__ + "static/media/ammo.208defa7.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/icons/ammo.svg
// module id = 2268
// module chunks = 7